import React from "react";

const Select = ({
  defaultValue,
  styleSelect,
  data,
  onChange,
  value,
  selectedValue,
  showDefaultOption = true,
}) => {
  return (
    <div className={"select"}>
      <select
        className={styleSelect}
        onChange={onChange}
        {...(selectedValue !== undefined && selectedValue !== null
          ? { value: selectedValue }
          : {})}
      >
        {showDefaultOption ? (
          <option value={defaultValue} defaultValue={defaultValue}>
            {defaultValue}
          </option>
        ) : null}
        {data.map((item, index) => (
          <option key={index} value={value ? value[index] : 0}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;